import { Button } from '@mui/material';
import { NewComponentSelectionDialog } from './NewComponentSelectionDialog';
import AddIcon from '@mui/icons-material/Add';
import { useCallback, useState } from 'react';

export const NewComponent = () => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleClick = useCallback(() => {
    setDialogOpen(true);
  }, []);

  const handleDialogClose = useCallback(() => {
    setDialogOpen(false);
  }, []);
  return (
    <>
      <NewComponentSelectionDialog onClose={handleDialogClose} open={dialogOpen} />
      <Button
        id="create-component"
        variant="contained"
        size="small"
        onClick={handleClick}
        startIcon={<AddIcon sx={{ fontSize: '1.6rem !important' }} />}
      >
        Create Component
      </Button>
    </>
  );
};
